/**
 * Any assemblies API calls with React Query.
 */
import { getAssemblyDynamicFilters } from "../../services/CourseService";
import { QUERY_CACHE_PROFILES, QUERY_KEYS } from "../queryConsts";
import { useBaseReactQuery } from "./useBaseReactQuery";

const EMPTY_ASSEMBLY_DYNAMIC_FILTERS = Object.freeze({
    course: [],
    school: [],
    qualification: [],
    version: [],
    intake: [],
});

/**
 * Assembly listing dropdown filter options - PERSISTED
 * @returns {DefinedUseQueryResult} React Query result
 */
export function useAssemblyDynamicFilters() {
    const query = useBaseReactQuery(
        [QUERY_KEYS.assemblies.root, QUERY_KEYS.assemblies.dynamicFilters],
        async () => {
            const { data } = await getAssemblyDynamicFilters();

            return data ?? EMPTY_ASSEMBLY_DYNAMIC_FILTERS;
        },
        {
            cacheProfile: QUERY_CACHE_PROFILES.LOOKUP
        }
    );

    return {
        ...query,
        data: query.data ?? EMPTY_ASSEMBLY_DYNAMIC_FILTERS
    };
}
